import { useEffect, useState } from 'react'
import { testimonials } from '../data/siteData'
import './TestimonialSlider.css'

export default function TestimonialSlider() {
  const [index, setIndex] = useState(0)

  useEffect(() => {
    const t = setInterval(() => {
      setIndex((i) => (i + 1) % testimonials.length)
    }, 6000)
    return () => clearInterval(t)
  }, [])

  const go = (i) => setIndex(((i % testimonials.length) + testimonials.length) % testimonials.length)

  return (
    <div className="testimonial-slider">
      <span className="testimonial-quote-mark" aria-hidden="true">&ldquo;</span>
      <div className="testimonial-track">
        {testimonials.map((t, i) => (
          <blockquote key={i} className={`testimonial ${i === index ? 'active' : ''}`}>
            <p>{t.quote}</p>
            <footer>
              <span className="testimonial-name">{t.name}</span>
              <span className="testimonial-role">{t.role}</span>
            </footer>
          </blockquote>
        ))}
      </div>
      <div className="testimonial-dots">
        {testimonials.map((_, i) => (
          <button
            key={i}
            className={`testimonial-dot ${i === index ? 'active' : ''}`}
            onClick={() => go(i)}
            aria-label={`Show testimonial ${i + 1}`}
          />
        ))}
      </div>
    </div>
  )
}
